import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { UserService } from '../services/user.service';
import { AuthService } from '../services/auth.service';
import { TicketChatService } from '../services/ticket-chat.service';
import { environment } from '../../../environments/environment';

export const authTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const userService = inject(UserService);
  const authService = inject(AuthService);
  const ticketChatService = inject(TicketChatService);

  const exceptedEndPoints: string[] = [
    'googleapis.com',
    'login'
  ];

  const noNeedToken = exceptedEndPoints.find(endPoint =>
    req.url.includes(endPoint)
  );

  if (noNeedToken) {
    return next(req);
  }

  const isChatApi = req.url.includes(environment.chatUrl);
  const chatAccess = ticketChatService.chatAccess();
  const token = isChatApi && chatAccess ? chatAccess.chat_token : userService.getToken();

  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        authService.logoutSuccess();
      }
      return throwError(() => error);
    })
  );
};
